import { render, staticRenderFns } from "./ChatStatusItem.vue?vue&type=template&id=16a4d1a0"
import script from "./ChatStatusItem.vue?vue&type=script&lang=js"
export * from "./ChatStatusItem.vue?vue&type=script&lang=js"
import style0 from "./ChatStatusItem.vue?vue&type=style&index=0&id=16a4d1a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports